import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { formatCentsToCurrency } from '../../../../utils/currency-helpers';

export const BalancePaid = ({ isMobile, balancePaid }: { isMobile: boolean; balancePaid?: number }) => {
  const { t } = useTranslation('payments');

  if (isMobile) {
    return (
      <>
        <Text color='subdued'>{t('Balance paid')}</Text>
        <Text weight='bold'>{formatCentsToCurrency(balancePaid || 0)}</Text>
      </>
    );
  }
  return (
    <>
      <Text
        css={css`
          color: ${theme.colors.neutral60};
        `}
      >
        {t('Balance paid')}
      </Text>
      <Text
        css={css`
          color: ${theme.colors.neutral80};
        `}
      >
        {formatCentsToCurrency(balancePaid || 0)}
      </Text>
    </>
  );
};
